import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

// eslint-disable-next-line
declare const ZOHO: any;

Vue.config.devtools = process.env.NODE_ENV === "development";
Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
  created: function async() {
    /* Initial Load */
    this.$store.dispatch("mainStore/initApp");
    /* Init SDK */
    ZOHO.embeddedApp.init();
  },
}).$mount("#app");

axios.interceptors.request.use(
  config => {
    const authToken = store.getters["authStore/getAuthToken"];
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  },
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const {
      config,
      response: { status /*, data*/ },
    } = error;

    if (status === 401) {
      console.log("Token Expired");
      const retryCounter = store.getters["authStore/getRetryCounter"];
      console.debug("current retryCount", retryCounter);
      if (retryCounter >= 5) {
        console.debug("Max auth retries reached");
        store.dispatch("mainStore/showMessage", {
          type: "error",
          text: `Max auth retries has been reached (${retryCounter}). Try to refresh the page.`,
        });
      } else {
        store.dispatch("authStore/incrementRetryCounter");
        try {
          await store.dispatch("authStore/authRefreshToken");
          return new Promise((resolve, reject) => {
            axios
              .request(config)
              .then(response => {
                store.dispatch("authStore/resetRetryCounter");
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          });
        } catch (error) {
          console.log(error);
          return Promise.reject(error);
        }
      }
    } else {
      return Promise.reject(error);
    }
  },
);
